import { LinkTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import React from "react";

export const tabProps = (
  link: string,
  component: React.ReactNode | OverridableComponent<LinkTypeMap<{}, "a">>
) => {
  return {
    id: `simple-tab-${link}`,
    "aria-controls": `simple-tabpanel-${link}`,
    component: component,
    href: `${link}`,
    underline: "none",
  };
};

/**
 * @param string which needs to be sliced
 * @param length
 * */
export const sliceString = (text: string, length: number) =>
  text.length > length ? `${text.slice(0, length)}...` : text;

/**
 * @param string
 * */
export default function toTitleCase(s: string) {
  if (s.length <= 0) return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export const getCookie = (name: string) => {
  let cookieValue = null;
  if (
    typeof document !== "undefined" &&
    document.cookie &&
    document.cookie !== ""
  ) {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
};

export const getDrawerWidth = (drawerList: string[], drawerName: string) => {
  if (Math.abs(drawerList.indexOf(drawerName)) + 1 === drawerList.length) {
    return 60;
  } else if (
    Math.abs(drawerList.indexOf(drawerName)) + 2 ===
    drawerList.length
  ) {
    return 90;
  } else if (
    Math.abs(drawerList.indexOf(drawerName)) + 3 ===
    drawerList.length
  ) {
    return 100;
  } else {
    return 60;
  }
};

export const removePropertyFromObject = (
  data: { [key: string]: string },
  prop: string
) => {
  return Object.keys(data)
    .filter((key) => key !== prop)
    .reduce(
      (acc, cur) => ({
        ...acc,
        [cur]: data[cur],
      }),
      {}
    );
};

export function nestedObjectToFormData(obj: object) {
  const formData = new FormData();
  Object.entries(obj).forEach(([key, val]) => {
    if (![undefined, null].includes(val)) {
      if (typeof val === "object" && !(val instanceof File)) {
        let data = nestedObjectToFormData(val);
        // @ts-ignore
        for (let [subKey, value] of data.entries()) {
          formData.append(`${key}[${subKey}]`, value);
        }
      } else {
        formData.append(key, val);
      }
    }
  });
  return formData;
}

export function formDataWithNestedJsonObject(obj: object) {
  const formData = new FormData();
  Object.entries(obj).forEach(([key, val]) => {
    if (![undefined, null].includes(val)) {
      if (typeof val === "object" && !(val instanceof File)) {
        formData.append(key, JSON.stringify(val));
      } else {
        formData.append(key, val);
      }
    }
  });
  return formData;
}

export const compareTwoArrayOfObjects = <
  T = { [key: string]: string | number | boolean }
>(
  firstArrayOfObjects: T[],
  secondArrayOfObjects: T[]
) => {
  return (
    firstArrayOfObjects.length === secondArrayOfObjects.length &&
    firstArrayOfObjects.every((element1) =>
      secondArrayOfObjects.some((element2) =>
        // @ts-ignore
        Object.keys(element1).every((key) => element1[key] === element2[key])
      )
    )
  );
};
